module.exports = __webpack_public_path__ + "static/img/about.a8c02f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/joinus/about.png
// module id = gKnx
// module chunks = 1